import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { useDeleteDepartmentOverride } from "@/hooks/useSupportDepartments";
import type { Department, DepartmentOverride } from "@/services/supportDepartmentsService";

import { apiErrorMessage } from "./slackId";

/** A Teamwork member removed from this department in Core. Greyed; Undo
 *  deletes the override so Teamwork decides again. */
export function RemovedPersonRow({
  override,
  department,
}: {
  override: DepartmentOverride;
  department: Department;
}) {
  const remove = useDeleteDepartmentOverride();
  const name = override.display_name || override.email;

  return (
    <li className="flex flex-wrap items-center gap-x-3 gap-y-2 py-2">
      <div className="min-w-[10rem] flex-1 opacity-60">
        <p className="text-sm font-medium text-muted-foreground line-through">{name}</p>
        <p className="text-xs text-muted-foreground">{override.email}</p>
      </div>
      <Badge variant="outline" className="text-muted-foreground">Removed in Core</Badge>
      <Button
        type="button"
        size="sm"
        variant="ghost"
        disabled={remove.isPending}
        aria-label={`Undo removal of ${name}`}
        onClick={() => remove.mutate({ department: department.key, email: override.email })}
      >
        Undo
      </Button>
      {remove.error ? (
        <p role="alert" className="w-full text-xs text-destructive">
          {apiErrorMessage(remove.error, "the change was not saved.")}
        </p>
      ) : null}
    </li>
  );
}
